const DEFAULT_QUERY_LABEL = 'All lessons'

export function updateLessonSearchLoadingQuery(query) {
  const label = query?.trim() || DEFAULT_QUERY_LABEL

  document.querySelectorAll('[data-lesson-search-loading-query]').forEach((element) => {
    element.textContent = label
  })
}

export function beginLessonResultsLoading(query) {
  updateLessonSearchLoadingQuery(query)

  const results = document.getElementById('search_results')
  results?.classList.add('is-search-pending')
  results?.setAttribute('aria-busy', 'true')
}

export function endLessonResultsLoading() {
  const results = document.getElementById('search_results')
  results?.classList.remove('is-search-pending')
  results?.removeAttribute('aria-busy')
}
